import { selectedTreatmentsJsonDecoder } from "decoders/selectedTreatmentOptionPaylodDecoder";
import { SelectedTreatmentPayloadType } from "domain/selectedTreatments";
import { envSettings } from "./envService";
import { createPost } from "./fetchService";
import { handleResponse } from "./util";

const { serviceHost } = envSettings();

export const postSelectedTreatmentOption = async (
  selectedTreatmentOptionPayload: SelectedTreatmentPayloadType
): Promise<SelectedTreatmentPayloadType> => {
  const post = createPost();
  const response = await post(`${serviceHost}/selectedTreatments`, {
    ...selectedTreatmentOptionPayload,
  });
  await handleResponse(selectedTreatmentsJsonDecoder, response);
  return selectedTreatmentOptionPayload;
};
